
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import { GetInstructionFile } from '@/components/utils/GetInstructionFile';

import "@/store/modules/application";
const applicationState = namespace("Application");

import { stepInfoType } from '@/types/Application';
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';

import JourneyMap from "../JourneyMap/JourneyMap.vue";
import appRightToAppealInstructions from "./pathwayInstructions/appRightToAppealInstructions.vue";
import appApplyLeaveInstructions from "./pathwayInstructions/appApplyLeaveInstructions.vue";
import appLeaveRefusedInstructions from "./pathwayInstructions/appLeaveRefusedInstructions.vue";
import appLeaveGrantedInstructions from "./pathwayInstructions/appLeaveGrantedInstructions.vue";
import appLeaveRefusedFinalInstructions from "./pathwayInstructions/appLeaveRefusedFinalInstructions.vue";
import appLeaveGrantedFinalInstructions from "./pathwayInstructions/appLeaveGrantedFinalInstructions.vue";

import rspToAppealInstructions from "./pathwayInstructions/rspToAppealInstructions.vue";
import rspToLeaveInstructions from "./pathwayInstructions/rspToLeaveInstructions.vue";
import rspToLeaveGrantedInstructions from "./pathwayInstructions/rspToLeaveGrantedInstructions.vue";
import rspToLeaveRefusedInstructions from "./pathwayInstructions/rspToLeaveRefusedInstructions.vue";
import rspToLeaveRefusedFinalInstructions from "./pathwayInstructions/rspToLeaveRefusedFinalInstructions.vue";

@Component({
    components:{
        JourneyMap,
        appRightToAppealInstructions,
        appApplyLeaveInstructions,
        appLeaveRefusedInstructions,
        appLeaveGrantedInstructions,
        appLeaveRefusedFinalInstructions,
        appLeaveGrantedFinalInstructions,
        rspToAppealInstructions,
        rspToLeaveInstructions,
        rspToLeaveGrantedInstructions,
        rspToLeaveRefusedInstructions,
        rspToLeaveRefusedFinalInstructions
    }
})
export default class AppealProcess extends Vue {

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;  

    @applicationState.State
    public steps!: stepInfoType[];

    appApplyLeave = false;
    appLeaveGranted = false;
    appLeaveRefused = false;
    appLeaveGrantedFinal = false;
    appLeaveRefusedFinal = false;
    appRightToAppeal = false;
    rspToAppeal = false;   
    rspToLeave = false; 
    rspToLeaveRefusedFinal = false;
    rspToLeaveRefused = false;
    rspToLeaveGranted = false;
    selfRep = false;

    mounted(){
        this.selfRep = this.$store.state.Common.userSelfRepresented;
        this.appApplyLeave = this.steps[this.stPgNo.APP_APPLY_LEAVE._StepNo].active;
        this.appLeaveGranted = this.steps[this.stPgNo.APP_LEAVE_GRANTED._StepNo].active;
        this.appLeaveRefused = this.steps[this.stPgNo.APP_LEAVE_REFUSED._StepNo].active;
        this.appLeaveGrantedFinal = this.steps[this.stPgNo.APP_LEAVE_GRANTED_FINAL._StepNo].active;
        this.appLeaveRefusedFinal = this.steps[this.stPgNo.APP_LEAVE_REFUSED_FINAL._StepNo].active;
        this.appRightToAppeal = this.steps[this.stPgNo.APP_RIGHT_TO_APPEAL._StepNo].active;
        this.rspToAppeal = this.steps[this.stPgNo.RSP_TO_APPEAL._StepNo].active;
        this.rspToLeave = this.steps[this.stPgNo.RSP_TO_LEAVE._StepNo].active;
        this.rspToLeaveGranted = this.steps[this.stPgNo.RSP_TO_LEAVE_GRANTED._StepNo].active;
        this.rspToLeaveRefused = this.steps[this.stPgNo.RSP_TO_LEAVE_REFUSED._StepNo].active;
        this.rspToLeaveRefusedFinal = this.steps[this.stPgNo.RSP_TO_LEAVE_REFUSED_FINAL._StepNo].active;
    }

    public downloadInstructions(){

        if(this.appRightToAppeal){
            GetInstructionFile('applying-pathway', '.pdf');
        } else if (this.rspToAppeal) {
            GetInstructionFile('responding-pathway', '.pdf');
        }

    }

}

